import { useRef, useState } from 'react';
import { api } from '../api';
import { useMe } from '../useData';
import { Avatar, bumpAvatars, resizeToSquare } from '../components/Avatar';
import { ErrorMsg } from '../components/Modal';
import { ThemePicker } from '../components/ThemePicker';
import { ChangePasswordForm } from './LoginPage';

export function ProfilePage({ onChanged }: { onChanged: () => void }) {
  const me = useMe();
  const fileRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function upload(file: File | undefined) {
    if (!file) return;
    setBusy(true);
    setError(null);
    setMsg(null);
    try {
      const dataUrl = await resizeToSquare(file);
      await api.put('/me/avatar', { dataUrl });
      bumpAvatars();
      onChanged();
      setMsg('Poza a fost actualizată.');
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  }

  async function remove() {
    setError(null);
    try {
      await api.del('/me/avatar');
      bumpAvatars();
      onChanged();
      setMsg('Poza a fost ștearsă.');
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <>
      <div className="page-head"><h1>Profilul meu</h1></div>
      <section className="profile">
        <Avatar userId={me.id} name={me.displayName} hasAvatar={me.hasAvatar} size={112} />
        <div>
          <h2 style={{ marginTop: 0 }}>{me.displayName}</h2>
          <p className="muted">{me.email}</p>
          <p className="muted small">
            Autentificat cu {me.authMethod === 'microsoft' ? `contul Microsoft 365${me.mfa ? ' (cu cod MFA ✓)' : ''}` : 'e-mail și parolă'}
          </p>
          <div className="actions" style={{ justifyContent: 'flex-start' }}>
            <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" hidden
              onChange={(e) => upload(e.target.files?.[0])} />
            <button className="primary" disabled={busy} onClick={() => fileRef.current?.click()}>
              {me.hasAvatar ? 'Schimbă poza' : 'Adaugă poză'}
            </button>
            {me.hasAvatar && <button onClick={remove}>Șterge poza</button>}
          </div>
          {msg && <p className="ok-msg">{msg}</p>}
          <ErrorMsg error={error} />
        </div>
      </section>

      <ThemePicker />

      {me.authMethod === 'password' && (
        <section style={{ maxWidth: 420 }}>
          <h2>Schimbă parola</h2>
          <ChangePasswordForm onDone={() => setMsg('Parola a fost schimbată.')} />
        </section>
      )}
    </>
  );
}
